<template>
    <div class="about2">
        <!--科技感背景装饰-->
        <div class="tech-bg" v-show="!showDetail">
            <div class="tech-orb tech-orb-1"></div>
            <div class="tech-orb tech-orb-2"></div>
            <div class="tech-orb tech-orb-3"></div>
            <div class="tech-orb tech-orb-4"></div>
        </div>
        <breadcrumb :guide="guide"></breadcrumb>
        <!--主体内容-->
        <div class="x-container" v-show="!showDetail">
            <!--标题与说明-->
            <div class="p-section-header">
                <div class="p-section-title-wrap">
                    <div class="title-glow-line"></div>
                    <p class="p-section-title">携手优秀企业，共筑GMOS生态</p>
                    <div class="title-glow-line"></div>
                </div>
            </div>
            <!--空数据-->
            <div class="no-data" v-if="showNoData">
                暂无数据
            </div>
            <div class="map-container" v-else>
                <div ref="chinaMap" class="china-map"></div>
            </div>
        </div>
        <div class="x-container" v-if="showDetail">
            <!--合作伙伴详细信息-->
            <div class="detail-content">
                <span class="back" @click="backToMain">&lt;&lt;返回</span>
                <div class="title-detail">
                    {{ detail.title }}
                </div>
                <div class="ge-title-label">公司简介</div>
                <div class="detail-desc">
                    {{ detail.description }}
                </div>
                <div v-if="detail.qualification.length > 0" class="ge-title-label">公司资质</div>
                <div v-if="!showMobile">
                    <div class="part" v-if="detail.qualification.length > 3">
                        <el-carousel trigger="click" :height="carouselHeight" indicator-position="outside">
                            <el-carousel-item v-for="(group, index) in groupedQualifications" :key="index">
                                <div class="flex-center">
                                    <el-image v-for="item in group" :key="item.id" class="img-1" :src="item.url"
                                        fit="fill" :preview-src-list="item.srcList" />
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div class="part" v-else>
                        <div class="flex-center">
                            <el-image v-for="item in detail.qualification" :key="item.id" class="img-1" :src="item.url"
                                :preview-src-list="item.srcList" fit="fill" />
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="part">
                        <el-carousel trigger="click" :height="mobileHeight" indicator-position="outside">
                            <el-carousel-item v-for="(item, index) in detail.qualification" :key="index">
                                <el-image class="img-1" :src="item.url" :preview-src-list="item.srcList" fit="fill" />
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
                <div class="ge-title-label">格力泰山授权证书</div>
                <div class="part">
                    <div v-for="(group, gIndex) in groupedAuthorizations" :key="gIndex + 'auth'" class="flex-center">
                        <el-image v-for="item in group" :key="item.id" class="img-2" :src="item.url"
                            :preview-src-list="item.srcList" />
                    </div>
                </div>
                <div class="ge-title-label" v-if="this.detail.development.length > 0">认证开发工程师</div>
                <div class="part">
                    <template v-if="this.detail.development.length >= 3">
                        <div v-for="(group, gIndex) in groupedDevelopments" :key="gIndex + 'auth'" class="flex-between">
                            <el-image v-for="item in group" :key="item.id" class="img-3" :src="item.url"
                                :preview-src-list="item.srcList" />
                        </div>
                    </template>
                    <template v-else>
                        <div v-for="(group, gIndex) in groupedDevelopments" :key="gIndex + 'auth'" class="flex-center">
                            <el-image v-for="item in group" :key="item.id" class="img-3" :src="item.url"
                                :preview-src-list="item.srcList" />
                        </div>
                    </template>
                </div>
                <div class="ge-title-label" v-if="this.detail.debug.length > 0">认证调试工程师</div>
                <div class="part">
                    <template v-if="this.detail.debug.length >= 3">
                        <div v-for="(group, gIndex) in groupedDebugs" :key="gIndex + 'auth'" class="flex-between">
                            <el-image v-for="item in group" :key="item.id" class="img-3" :src="item.url"
                                :preview-src-list="item.srcList" />
                        </div>
                    </template>
                    <template v-else>
                        <div v-for="(group, gIndex) in groupedDebugs" :key="gIndex + 'auth'" class="flex-center">
                            <el-image v-for="item in group" :key="item.id" class="img-3" :src="item.url"
                                :preview-src-list="item.srcList" />
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <!--省份合作伙伴弹窗-->
        <el-dialog :visible.sync="showProvinceDialog" :width="dialogWidth" top="calc(8vh + 40px)" :close-on-click-modal="true" custom-class="province-dialog">
            <div slot="title" class="dialogTitle">{{ selectedProvinceName }}授权服务商</div>
            <div class="province-card-grid" :class="{ 'single-column': selectedProvincePartners.length <= 1 }">
                <section class="p-card" v-for="(item, index) in selectedProvincePartners" :key="index" @click="getMoreInfo(item)">
                    <div class="p-card-top">
                        <div class="p-card-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M3 21h18" />
                                <path d="M5 21V7l7-4 7 4v14" />
                                <path d="M9 21v-6h6v6" />
                                <path d="M9 9h.01" />
                                <path d="M15 9h.01" />
                                <path d="M9 13h.01" />
                                <path d="M15 13h.01" />
                            </svg>
                        </div>
                        <div class="p-card-title" :title="item.name">{{ item.name }}</div>
                    </div>
                    <div class="p-card-divider"></div>
                    <div class="p-card-desc" :title="item.description">{{ item.description }}</div>
                    <div class="p-card-footer">
                        <div class="p-card-address">
                            <svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                                <circle cx="12" cy="10" r="3" />
                            </svg>
                            <span>{{ item.address }}</span>
                        </div>
                        <span class="p-more-link">
                            更多
                            <svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <line x1="5" y1="12" x2="19" y2="12" />
                                <polyline points="12 5 19 12 12 19" />
                            </svg>
                        </span>
                    </div>
                </section>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb'
import { mapGetters } from "vuex";
import { getAllPartners } from '@/api/partners'
import city from '@/assets/json/city'
import province from '@/assets/json/province'
import * as echarts from 'echarts';
import chinaJson from '@/utils/china.json';

export default {
    name: "partners",
    components: {
        breadcrumb,
        "ge-title-label": () => import("@/components/titleLabel"),
    },
    computed: {
        showNoData() {
            if (this.materialList.length === 0) {
                return true;
            }
            return false;
        },
        dialogWidth() {
            if (this.selectedProvincePartners.length <= 1) {
                return '580px';
            } else {
                return '1124px';
            }
        },
        ...mapGetters(['getUserName']),
        groupedQualifications() {
            const result = [];
            const len = this.detail.qualification.length;
            for (let i = 0; i < len; i += 3) {
                result.push(this.detail.qualification.slice(i, i + 3));
            }
            return result;
        },
        groupedAuthorizations() {
            const result = [];
            const len = this.detail.authorization.length;
            for (let i = 0; i < len; i += 2) {
                result.push(this.detail.authorization.slice(i, i + 2));
            }
            return result;
        },
        groupedDevelopments() {
            const result = [];
            const len = this.detail.development.length;
            for (let i = 0; i < len; i += 4) {
                result.push(this.detail.development.slice(i, i + 4));
            }
            return result;
        },
        groupedDebugs() {
            const result = [];
            const len = this.detail.debug.length;
            for (let i = 0; i < len; i += 4) {
                result.push(this.detail.debug.slice(i, i + 4));
            }
            return result;
        },
    },
    data() {
        return {
            mobileHeight: 0,
            showMobile: false,
            detail: {},
            showDetail: false,
            guide: [
                { label: '服务与支持' },
                { label: '授权服务商' },
            ],
            materialList: [],
            carouselHeight: "223px",
            mapChart: null,
            selectedProvincePartners: [],
            selectedProvinceName: '',
            provincePartnerMap: {},
            showProvinceDialog: false,
        }
    },
    methods: {
        getImageSize(imgUrl) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => {
                    resolve({
                        width: img.naturalWidth,
                        height: img.naturalHeight
                    });
                };
                img.onerror = () => {
                    reject(new Error('图片加载失败'));
                };
                img.src = imgUrl;
            });
        },
        //省份中文和值的一一对应，'reverse'为true表示从中文到id，否则表示从id到中文
        getProvinceMapping(param, reverse = false) {
            if (reverse) {
                return province.find((item) => item.name === param)?.id || '';
            } else {
                return province.find((item) => item.id === param)?.name || '';
            }
        },
        //城市中文和值的一一对应，'reverse'为true表示从中文到id，否则表示从id到中文
        getCityMapping(param, reverse = false) {
            for (let provinceCode in city) {
                let cities = city[provinceCode];
                for (let cityInfo of cities) {
                    if (reverse) {
                        if (cityInfo.name === param) {
                            return cityInfo.id;
                        }
                    } else {
                        if (cityInfo.id === param) {
                            return cityInfo.name;
                        }
                    }
                }
            }
            return '';
        },
        getAllPartners(callback) {
            getAllPartners().then((res) => {
                this.materialList = res.returnData;
                this.materialList.map(item => {
                    item.address = this.getProvinceMapping(item.province) + this.getCityMapping(item.city) + item.addressDetail;
                });
                this.materialList = this.materialList.reverse();
                if (callback) callback();
            })
        },
        showEllipsis(text, num) {
            if (text.length > num) {
                return text.substring(0, num) + '......';
            } else {
                return text;
            }
        },
        initMap() {
            echarts.registerMap('china', chinaJson);
            const chartDom = this.$refs.chinaMap;
            if (!chartDom) return;
            this.mapChart = echarts.init(chartDom);

            // 省份名称 → 坐标映射（从 china.json 的 properties.center 提取）
            const provinceCoords = {};
            chinaJson.features.forEach(f => {
                const name = f.properties.name;
                const center = f.properties.center || f.properties.centroid;
                if (center) {
                    provinceCoords[name] = center;
                }
            });

            // 按省份分组，每省份只取一个发光点
            const scatterData = [];
            const provincePartnerMap = {};
            this.materialList.forEach(item => {
                const provinceName = this.getProvinceMapping(item.province);
                const coord = provinceCoords[provinceName];
                if (coord) {
                    if (!provincePartnerMap[provinceName]) {
                        provincePartnerMap[provinceName] = [];
                    }
                    provincePartnerMap[provinceName].push(item);
                    // 只在该省份第一次出现时添加发光点
                    if (provincePartnerMap[provinceName].length === 1) {
                        scatterData.push({
                            name: provinceName,
                            provinceName: provinceName,
                            value: [coord[0], coord[1]],
                        });
                    }
                }
            });
            this.provincePartnerMap = provincePartnerMap;

            // 计算最大合作伙伴数，用于颜色深浅
            const maxCount = Math.max(...Object.values(provincePartnerMap).map(arr => arr.length), 1);

            // 为每个省份生成颜色（合作伙伴越多颜色越深）
            const provinceColorMap = {};
            for (const name in provincePartnerMap) {
                const count = provincePartnerMap[name].length;
                // 颜色从 #eef3fb（浅）到 #1f58ff（深）渐变
                const ratio = count / maxCount;
                const lightR = 238, lightG = 243, lightB = 251;
                const darkR = 31, darkG = 88, darkB = 255;
                const r = Math.round(lightR + (darkR - lightR) * ratio);
                const g = Math.round(lightG + (darkG - lightG) * ratio);
                const b = Math.round(lightB + (darkB - lightB) * ratio);
                provinceColorMap[name] = `rgb(${r},${g},${b})`;
            }

            const tooltipFormatter = function(params) {
                var provinceName = '';
                if (params.data && params.data.provinceName) {
                    provinceName = params.data.provinceName;
                } else if (params.name) {
                    provinceName = params.name;
                }
                if (!provinceName) return '';
                var list = provincePartnerMap[provinceName] || [];
                if (list.length === 0) return '';
                var html = '<div style="text-align:left;">';
                list.forEach(function(item) {
                    html += '<div style="line-height:22px;">' + item.name + '</div>';
                });
                html += '</div>';
                return html;
            };

            const option = {
                tooltip: {
                    trigger: 'item',
                    position: function(point, params, dom, rect, size) {
                        var x = point[0] + 15;
                        var y = point[1] - size.contentSize[1] - 10;
                        if (y < 0) y = point[1] + 15;
                        return [x, y];
                    },
                    backgroundColor: '#fff',
                    borderColor: '#b0c4de',
                    borderWidth: 1,
                    borderRadius: 4,
                    padding: [8, 12],
                    textStyle: {
                        fontSize: 13,
                        color: '#333',
                    },
                    formatter: tooltipFormatter,
                },
                geo: {
                    map: 'china',
                    roam: false,
                    zoom: 1.2,
                    tooltip: {
                        show: true,
                        formatter: tooltipFormatter,
                    },
                    label: {
                        show: true,
                        color: '#cacdd5',
                        fontSize: 10,
                    },
                    regions: Object.keys(provinceColorMap).map(name => ({
                        name: name,
                        itemStyle: {
                            areaColor: provinceColorMap[name],
                        },
                    })),
                    itemStyle: {
                        areaColor: '#eef3fb',
                        borderColor: '#4992ff',
                        borderWidth: 0.8,
                    },
                    emphasis: {
                        itemStyle: {
                            areaColor: '#d6e4f5',
                            borderColor: '#1f58ff',
                        },
                        label: {
                            show: true,
                            color: '#1f58ff',
                            // color: '#ff6600',
                            fontWeight: 'bold',
                        },
                    },
                },
                series: [{
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    data: scatterData,
                    symbolSize: 12,
                    showEffectOn: 'render',
                    rippleEffect: {
                        brushType: 'stroke',
                        scale: 4,
                        period: 3,
                    },
                    label: {
                        show: false,
                    },
                    itemStyle: {
                        color: '#ff9500',
                        shadowBlur: 10,
                        shadowColor: '#ff9500',
                    },
                    emphasis: {
                        scale: 1.8,
                        itemStyle: {
                            color: '#ff6600',
                            shadowBlur: 20,
                            shadowColor: '#ff6600',
                            borderColor: '#ff9500',
                            borderWidth: 2,
                        },
                    },
                }],
            };

            this.mapChart.setOption(option);

            // 点击省份或发光点 → 弹窗显示该省份公司列表
            this.mapChart.on('click', (params) => {
                let provinceName = '';
                if (params.data && params.data.provinceName) {
                    provinceName = params.data.provinceName;
                } else if (params.name) {
                    provinceName = params.name;
                }
                if (provinceName && this.provincePartnerMap[provinceName]) {
                    this.selectedProvinceName = provinceName;
                    this.selectedProvincePartners = this.provincePartnerMap[provinceName] || [];
                    this.showProvinceDialog = true;
                }
            });
        },
        resizeMap() {
            if (this.mapChart) {
                this.mapChart.resize();
            }
            this.resizeWindow();
        },
        clearSelectedProvince() {
            this.selectedProvinceName = '';
            this.selectedProvincePartners = [];
        },
        getMoreInfo(info) {
            this.showProvinceDialog = false;
            this.detail = {
                title: info.name,
                description: info.description,
                qualification: [],
                authorization: [],
                development: [],
                debug: [],
            }
            info.certificateImages.map((item) => {
                switch (item.certificateTypeId) {
                    case 1:
                        this.detail.qualification.push(
                            {
                                id: item.imageId,
                                url: this.$commonPicUrl + item.imgUrl,
                                srcList: [this.$commonPicUrl + item.imgUrl],
                            }
                        );
                        break;
                    case 2:
                        this.detail.authorization.push(
                            {
                                id: item.imageId,
                                url: this.$commonPicUrl + item.imgUrl,
                                srcList: [this.$commonPicUrl + item.imgUrl],
                            }
                        );
                        break;
                    case 3:
                        this.detail.development.push(
                            {
                                id: item.imageId,
                                url: this.$commonPicUrl + item.imgUrl,
                                srcList: [this.$commonPicUrl + item.imgUrl],
                            }
                        );
                        break;
                    case 4:
                        this.detail.debug.push(
                            {
                                id: item.imageId,
                                url: this.$commonPicUrl + item.imgUrl,
                                srcList: [this.$commonPicUrl + item.imgUrl],
                            }
                        );
                        break;
                }
            });
            this.showDetail = true;
            this.getImageSize(this.detail.qualification[0]?.url)
                .then(size => {
                    if (size.width < size.height) {
                        this.carouselHeight = "450px";
                        this.mobileHeight = '300px';
                    } else {
                        this.carouselHeight = "223px";
                        this.mobileHeight = '160px';
                    }
                })
                .catch(err => {
                    console.error(err.message);
                });
        },
        backToMain() {
            this.showDetail = false;
            this.detail = {};
        },
        resizeWindow() {
            this.showMobile = document.documentElement.clientWidth < 768 ? true : false;
        }
    },
    mounted() {
        this.getAllPartners(() => {
            this.$nextTick(() => {
                this.initMap();
            });
        });
        this.resizeWindow();
        window.addEventListener("resize", this.resizeMap);
    },
    destroyed() {
        window.removeEventListener("resize", this.resizeMap);
        if (this.mapChart) {
            this.mapChart.dispose();
        }
    },
}
</script>

<style scoped lang="less">
/*头部背景图*/
.bakTop {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
}

/*科技感背景装饰*/
.tech-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 0;
    overflow: hidden;
}

.tech-orb {
    position: absolute;
    border-radius: 50%;
    filter: blur(80px);
    opacity: 0.12;
    animation: orbFloat 10s ease-in-out infinite alternate;
}

.tech-orb-1 {
    width: 400px;
    height: 400px;
    background: #1f58ff;
    top: 8%;
    left: 3%;
}

.tech-orb-2 {
    width: 500px;
    height: 500px;
    background: #ff9500;
    bottom: 3%;
    right: 8%;
    animation-delay: 2s;
}

.tech-orb-3 {
    width: 300px;
    height: 300px;
    background: #1f58ff;
    top: 45%;
    right: 3%;
    animation-delay: 4s;
}

.tech-orb-4 {
    width: 350px;
    height: 350px;
    background: #ff9500;
    top: 60%;
    left: 10%;
    opacity: 0.08;
    animation-delay: 6s;
}

@keyframes orbFloat {
    0% { transform: translate(0, 0) scale(1); }
    100% { transform: translate(40px, -40px) scale(1.15); }
}

.tech-line {
    position: absolute;
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, rgba(31, 88, 255, 0.5) 50%, transparent 100%);
    animation: linePulse 4s ease-in-out infinite;
}

.tech-line-1 {
    width: 60%;
    top: 15%;
    left: 20%;
    animation-delay: 0s;
}

.tech-line-2 {
    width: 40%;
    top: 75%;
    right: 5%;
    animation-delay: 1.5s;
    background: linear-gradient(90deg, transparent 0%, rgba(255, 149, 0, 0.4) 50%, transparent 100%);
}

.tech-line-3 {
    width: 50%;
    top: 85%;
    left: 10%;
    animation-delay: 3s;
}

@keyframes linePulse {
    0%, 100% { opacity: 0.3; transform: scaleX(0.8); }
    50% { opacity: 0.8; transform: scaleX(1); }
}

/*标题样式*/
.p-section-header {
    padding: 10px 0 10px;
    text-align: center;
    position: relative;
    z-index: 1;
}

.p-section-title-wrap {
    display: inline-flex;
    align-items: center;
    gap: 20px;
}

.title-glow-line {
    width: 60px;
    height: 1px;
    background: linear-gradient(90deg, transparent, #1f58ff, transparent);
}

.p-section-title {
    font-size: 32px;
    font-weight: 700;
    background: linear-gradient(135deg, #2c4ba6, #1f58ff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    letter-spacing: 2px;
    margin: 0;
}

/*地图容器*/
.map-container {
    width: 100%;
    padding-bottom: 40px;
    position: relative;
    z-index: 1;
}

.map-frame {
    position: relative;
    border-radius: 8px;
    overflow: visible;
}

.map-corner {
    position: absolute;
    width: 20px;
    height: 20px;
    border: 2px solid #1f58ff;
    z-index: 10;
    pointer-events: none;
}

.map-corner-tl {
    top: -2px;
    left: -2px;
    border-right: none;
    border-bottom: none;
    border-radius: 8px 0 0 0;
}

.map-corner-tr {
    top: -2px;
    right: -2px;
    border-left: none;
    border-bottom: none;
    border-radius: 0 8px 0 0;
}

.map-corner-bl {
    bottom: -2px;
    left: -2px;
    border-right: none;
    border-top: none;
    border-radius: 0 0 0 8px;
}

.map-corner-br {
    bottom: -2px;
    right: -2px;
    border-left: none;
    border-top: none;
    border-radius: 0 0 8px 0;
}

.china-map {
    width: 100%;
    // height: 1000px;
    // background-color: #14192d;
    border-radius: 8px;
}

.p-section-title {
    font-size: 32px;
    font-weight: 700;
    color: #1a1a2e;
    letter-spacing: 1px;
    position: relative;
    display: inline-block;

    // &::after {
    //     content: '';
    //     position: absolute;
    //     bottom: -10px;
    //     left: 0;
    //     width: 48px;
    //     height: 3px;
    //     background: #1f58ff;
    //     border-radius: 2px;
    // }
}

.p-section-subtitle {
    margin-top: 20px;
    font-size: 15px;
    color: #999;
}

/*地图容器*/
.map-container {
    width: 100%;
    padding-bottom: 40px;
}

.china-map {
    width: 100%;
    height: 1000px;
}

/deep/ .el-dialog__body {
  padding: 0px 20px 30px 20px;
}

/*弹窗样式*/
.dialogTitle {
    font-size: 18px;
    color: #224E7F;
    text-align: left;
    font-weight: bold;
    border-bottom: 1px solid #EEEEEE;
}

.province-card-grid {
    display: grid;
    grid-template-columns: repeat(2, 520px);
    gap: 24px;
    justify-content: center;
    padding: 5px 20px 20px;

    &.single-column {
        grid-template-columns: 520px;
    }
}

/*卡片样式（沿用副本）*/
.p-card {
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 6px;
    padding: 10px 28px 18px;
    cursor: pointer;
    text-align: left;
    box-sizing: border-box;
    transition: all 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    transform: translateY(24px);
    animation: pCardFadeIn 0.6s ease forwards;

    &:hover {
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
        border-color: #1f58ff;
    }
}

.p-card-top {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
}

.p-card-icon {
    width: 38px;
    height: 38px;
    background: #f5f6f8;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    

    svg {
        width: 20px;
        height: 20px;
        stroke: #555;
        transition: stroke 0.3s;
    }
}

.p-card:hover .p-card-icon {
    background: #1f58ff;
}

.p-card:hover .p-card-icon svg {
    stroke: #fff;
}

.p-card-title {
    font-size: 17px;
    font-weight: 700;
    color: #1a1a2e;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.p-card-divider {
    width: 32px;
    height: 2px;
    background: #e8e8e8;
    margin-bottom: 14px;
    border-radius: 2px;
    transition: all 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.p-card:hover .p-card-divider {
    width: 48px;
    background: #1f58ff;
}

.p-card-desc {
    font-size: 16px;
    color: #666;
    line-height: 1.7;
    margin-bottom: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 52px;
}


.p-card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #f5f5f5;
    padding-top: 10px;
}

.p-card-address {
    font-size: 12px;
    color: #b0b0b0;
    display: flex;
    align-items: center;
    gap: 5px;
    flex: 1;
    min-width: 0;
    padding-right: 12px;

    svg {
        width: 14px;
        height: 14px;
        stroke: #b0b0b0;
        flex-shrink: 0;
    }

    span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

.p-more-link {
    font-size: 13px;
    color: #999;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    transition: color 0.3s;

    svg {
        width: 14px;
        height: 14px;
        stroke: currentColor;
        transition: transform 0.3s ease;
    }
}

.p-card:hover .p-more-link {
    color: #1f58ff;
}

.p-card:hover .p-more-link svg {
    transform: translateX(4px);
}

@media only screen and (max-width: 767px) {
    .china-map {
        height: 800px;
    }

    .province-card-grid {
        grid-template-columns: 1fr;
    }
}

.map-layout {
    display: flex;
    gap: 20px;
}

.china-map {
    flex: 2;
    height: 1000px;
}

.partner-list-panel {
    flex: 1;
    height: 1000px;
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.placeholder-panel .panel-body {
    color: #ccc;
}

.panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 2px solid #f0f0f0;
}

.panel-title {
    font-size: 18px;
    font-weight: bold;
    color: #1a1a2e;
}

.panel-close {
    font-size: 18px;
    color: #999;
    cursor: pointer;
    line-height: 1;
}

.panel-close:hover {
    color: #1f58ff;
}

.panel-body {
    flex: 1;
    overflow-y: auto;
    padding: 10px;
}

/*卡片样式（沿用副本）*/
.p-card {
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 6px;
    padding: 30px 28px 18px;
    cursor: pointer;
    text-align: left;
    box-sizing: border-box;
    transition: all 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    transform: translateY(24px);
    margin-bottom: 12px;
    animation: pCardFadeIn 0.6s ease forwards;

    &:hover {
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
        border-color: #1f58ff;
    }
}

.p-card-top {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
}

.p-card-icon {
    width: 34px;
    height: 34px;
    background: #f5f6f8;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.3s ease;

    svg {
        width: 18px;
        height: 18px;
        stroke: #555;
    }
}

.p-card:hover .p-card-icon {
    background: #1f58ff;
}

.p-card:hover .p-card-icon svg {
    stroke: #fff;
}

.p-card-title {
    font-size: 16px;
    font-weight: 700;
    color: #1a1a2e;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.p-card-divider {
    width: 32px;
    height: 2px;
    background: #e8e8e8;
    margin-bottom: 10px;
    border-radius: 2px;
    transition: all 0.3s ease;
}

.p-card:hover .p-card-divider {
    width: 48px;
    background: #1f58ff;
}

.p-card-desc {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    margin-bottom: 10px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 44px;
}

.p-card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #f5f5f5;
    padding-top: 8px;
}

.p-card-address {
    font-size: 12px;
    color: #b0b0b0;
    display: flex;
    align-items: center;
    gap: 5px;
    flex: 1;
    min-width: 0;
    padding-right: 10px;

    svg {
        width: 14px;
        height: 14px;
        stroke: #b0b0b0;
        flex-shrink: 0;
    }

    span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

.p-more-link {
    font-size: 13px;
    color: #999;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    transition: color 0.3s;

    svg {
        width: 14px;
        height: 14px;
        stroke: currentColor;
        transition: transform 0.3s ease;
    }
}

.p-card:hover .p-more-link {
    color: #1f58ff;
}

.p-card:hover .p-more-link svg {
    transform: translateX(4px);
}

@media only screen and (max-width: 767px) {
    .map-layout {
        flex-direction: column;
    }

    .china-map {
        height: 400px;
        flex: none;
    }

    .partner-list-panel {
        flex: none;
        width: 100%;
        height: 400px;
    }
}

/deep/ .el-carousel__button {
    background-color: #58d9f9;
    border-radius: 5px;
    opacity: 0.4;
    height: 5px;
}
</style>
<style lang="less" scoped>
@media only screen and (max-width: 767px) {
    .img-1:nth-child(3n + 1) {
        // margin-left: 0px;
    }

    .img-1 {
        width: 15rem;
    }
}

@media only screen and (min-width: 768px) {
    .img-1:nth-child(3n + 4) {
        margin-left: 0px;
    }

    .img-1 {
        width: 320px;
        margin: 0 0.5rem;
    }
}

@media only screen and (max-width: 699px) {
    .img-2 {
        width: 15rem;
        aspect-ratio: 1.38889;
        margin-bottom: 0.5rem;
    }
}

@media only screen and (min-width: 700px) {
    .img-2 {
        width: 320px;
        aspect-ratio: 1.38889;
        margin-bottom: 0.5rem;
    }
}

@media only screen and (max-width: 699px) {
    .img-3 {
        width: 9rem;
        aspect-ratio: 0.6977;
        margin: 0 0.5rem 0.5rem 0.5rem;
    }
}

@media only screen and (min-width: 700px) {
    .img-3 {
        width: 240px;
        aspect-ratio: 0.6977;
        margin: 0 0.5rem 0.5rem 0.5rem;
    }
}

.x-container {
    color: #333333;
    padding-top: 0;

    @media (min-width: 1200px) {
        width: 1600px !important;
    }
}

.title-detail {
    margin-top: 1rem;
    margin-bottom: 2rem;
    font-weight: bold;
    font-size: 1.5rem;
}

.ge-title-label {
    margin: 1rem;
    text-align: center;
    font-size: 1.2rem;
    font-weight: bold;
    color: #4988d6;
}

.detail-content {
    width: calc(100% - 2rem);
    margin: auto;
}

.back {
    display: block;
    font-size: 0.667rem;
    text-align: left;
    cursor: pointer;
}

.detail-desc {
    text-align: left;
    font-size: 0.875rem;
    text-indent: 2em;
    line-height: 1.5;
    color: #808080;
}

.part {
    width: 92%;
    margin: 0 auto;
}

.flex-start {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}

.flex-center {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}

.flex-between {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

@media only screen and (max-width: 767px) {
    .p-section-title {
        font-size: 24px;
    }

    .p-section-subtitle {
        font-size: 13px;
    }
}
</style>
